<template>
  <div class="md-layout">
    <md-card class="md-layout-item md-size-50 md-small-size-100">
      <md-card-header>
        <div class="md-title">Email Provider Settings</div>
      </md-card-header>
      <md-card-content>
        <md-field>
          <label for="email-provider">Email Provider</label>
          <md-select
            v-model="selectedProvider"
            id="email-provider"
            name="email-provider"
          >
            <md-option value="rails_mailer">SMTP</md-option>
            <md-option value="aws_ses">AWS SES</md-option>
          </md-select>
        </md-field>
        <md-button class="md-raised md-primary" @click="openConfirmDialog">
          Save Provider
        </md-button>
        <p v-if="statusMessage" class="mt-2 text-sm text-green-600">
          {{ statusMessage }}
        </p>
        <p class="text-sm">
          <strong>Effective Provider:</strong> {{ effectiveProviderLabel }}
        </p>
        <p class="text-sm">
          <strong>Last Updated:</strong> {{ new Date(updatedAt).toLocaleString() }}
        </p>
      </md-card-content>
    </md-card>

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Confirm Provider Change</md-dialog-title>
      <md-dialog-content>
        Are you sure you want to change the email provider to
        <strong>{{ selectedProviderLabel }}</strong>?
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="confirmUpdate">Yes</md-button>
        <md-button @click="showDialog = false">Cancel</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script type="ts">
import Vue from 'vue';
import SystemSettingsService from '@/services/system-setting/SystemSettingsService';
import SelectProvider from '@/datatypes/system-setting/select-provider';

export default Vue.extend({
  name: 'SmtpSettings',
  data() {
    return {
      selectedProvider: '',
      statusMessage: '',
      effectiveProvider: '',
      updatedAt: '',
      showDialog: false,
      systemSettingsService: new SystemSettingsService(),
    };
  },
  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },
  computed: {
    effectiveProviderLabel() {
      return this.getProviderLabel(this.effectiveProvider);
    },
    selectedProviderLabel() {
      return this.getProviderLabel(this.selectedProvider);
    },
  },

  methods: {
    routeChanged() {
      this.getSystemSettings();
    },

    getProviderLabel(providerKey) {
      /* eslint-disable @typescript-eslint/camelcase */
      const PROVIDER_LABELS = {
        rails_mailer: 'SMTP',
        aws_ses: 'AWS SES',
      };
      /* eslint-enable @typescript-eslint/camelcase */
      return PROVIDER_LABELS[providerKey] || providerKey || 'Unknown';
    },

    getSystemSettings() {
      this.systemSettingsService.getSettings().then((response) => {
        this.selectedProvider = response.data.email_provider;
        this.effectiveProvider = response.data.effective_email_provider;
        this.updatedAt = response.data.updated_at;
      });
    },

    openConfirmDialog() {
      this.showDialog = true;
    },

    confirmUpdate() {
      this.showDialog = false;
      const provider = new SelectProvider({ emailProvider: this.selectedProvider });
      this.systemSettingsService.updateEmailProvider(provider.complete())
        .then(() => {
          this.getSystemSettings();
          this.statusMessage = 'Email provider updated successfully.';
        })
        .catch(() => {
          this.statusMessage = 'Failed to update provider.';
        });
    },
  },
});
</script>

<style scoped>
.vertical-spacing.half {
  margin-top: 1rem;
}
</style>
